export default {"src":"/_next/static/media/comment-tree-branch.02b9f224.svg","height":41,"width":15,"blurWidth":0,"blurHeight":0};